<template>
  <div id="map-controls-sidebar">
    <sidebar-layers />
    <sidebar-search :map="map" />
    <sidebar-own-vessel :map="map" />
    <sidebar-selected-vessel :map="map" />
    <sidebar-filter />
    <sidebar-plot />
    <sidebar-private-plot />
    <sidebar-weather />
    <sidebar-vehicle />
    <sidebar-settings />
    <sidebar-anchor :map="map" />
    <sidebar-vessel-equipment-base-stations :map="map" />
  </div>
</template>

<script>
import SidebarLayers from "./items/layers/Layers";
import SidebarSearch from "./items/search/Search";
import SidebarOwnVessel from "./items/own-vessel/OwnVessel";
import SidebarSelectedVessel from "./items/selected-vessel/SelectedVessel";
import SidebarFilter from "./items/filter/Filter";
import SidebarPlot from "./items/plot/Plot";
import SidebarPrivatePlot from "./items/private-plot/PrivatePlot";
import SidebarWeather from "./items/weather/Weather";
import SidebarVehicle from "./items/vehicle/VehicleHeavyEquipment";
import SidebarSettings from "./items/settings/Settings";
import SidebarAnchor from "@/components/organisms/SidebarAnchor";
import SidebarVesselEquipmentBaseStations from "@/components/organisms/SidebarVesselEquipmentBaseStations";

export default {
  components: {
    SidebarLayers,
    SidebarSearch,
    SidebarOwnVessel,
    SidebarSelectedVessel,
    SidebarFilter,
    SidebarPlot,
    SidebarPrivatePlot,
    SidebarWeather,
    SidebarVehicle,
    SidebarSettings,
    SidebarAnchor,
    SidebarVesselEquipmentBaseStations,
  },
  props: {
    map: Object,
  },
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {},
};
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";
#map-side-menu {
  z-index: 58000;
  .vs-sidebar {
    position: fixed;
    z-index: 58000;
    width: 400px;
    max-width: 90vw;
    opacity: 1;
    box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.11),
      0 5px 15px 0 rgba(0, 0, 0, 0.08);
  }
}

.side-menu-btn {
  .vs-button {
    border-radius: 5px 0 0 5px;
  }

  position: fixed;
  top: 250px;
  right: 0;
  z-index: 50000;
}

.scroll-area--customizer {
  height: calc(100% - 5rem);

  &:not(.ps) {
    overflow-y: auto;
  }
}

.live-map-controls-close {
  color: $aisea-white;
}
</style>
